import { HttpContextToken } from "@angular/common/http";

export const API_NAME = new HttpContextToken<string | undefined>(
  () => undefined
);

export enum MODULES {
  Activities = "Activities",
  Emails = "Emails",
  Client = "Client",
  ClientForm = "ClientForm",
  ClientGroup = "ClientGroup",
  BusinessDevelopmentForm = "BusinessDevelopmentForm",
  BusinessDevelopment = "BusinessDevelopment",
  BusinessDevelopmentSlip = "BusinessDevelopmentSlip",
  Slips = "Slips",
  SlipsForm = "SlipsForm",
  Production = "Production",
  ProductionMembers = "ProductionMembers",
  ProductionForm = "ProductionForm",
  EditCommission = "EditCommission",
  CustomerService = "CustomerService",
  CustomerServiceForm = "CustomerServiceForm",
  CustomerServiceOnlineRequests = "CustomerServiceOnlineRequests",
  CustomerServiceComplaints = "CustomerServiceComplaints",
  CustomerServiceOnlineComplaints = "CustomerServiceOnlineComplaints",
  Claims = "Claims",
  ClaimsForm = "ClaimsForm",
  OnlineClaims = "OnlineClaims",
  SystemAdmin = "SystemAdmin",
  InsuranceClasses = "InsuranceClasses",
  LineOfBusiness = "LineOfBusiness",
  InsuranceCompanies = "InsuranceCompanies",
  QuotingRequirements = "QuotingRequirements",
  PolicyIssuanceRequirements = "PolicyIssuanceRequirements",
  MasterTableProductionLibraries = "MasterTableProductionLibraries",
  InsuranceCompaniesDocuments = "InsuranceCompaniesDocuments",
  CustomerServiceCompanyRequirements = "CustomerServiceCompanyRequirements",
  Hospitals = "Hospitals",
  InsuranceWorkshopDetails = "InsuranceWorkshopDetails",
  ClaimsGeneralItems = "ClaimsGeneralItems",
  ClaimsStatus = "ClaimsStatus",
  ClaimsRejectionReasons = "ClaimsRejectionReasons",
  MasterTableListOfRequiredDocuments = "MasterTableListOfRequiredDocuments",
  DefaultEmails = "DefaultEmails",
  Reports = "Reports",
  LoansRequest = "LoansRequest",
  MedicalProfile = "MedicalProfile",
  VacationRequest = "VacationRequest",
  RequestService = "RequestService",
  ExcuseRequest = "ExcuseRequest",
  ProductionEntries = "ProductionEntries",
  JournalVoucher = "JournalVoucher",
  ReceiptVouchers = "ReceiptVouchers",
  ClientsChasing = "ClientsChasing",
  ChequeDetails = "ChequeDetails",
  FinanceReports = "FinanceReports",
  StatementAccount = "StatementAccount",
}

export enum COMPONENT {
  AgGridClients = "AgGridClients",
  AgGridMembersType = "AgGridMembersType",
  AgGridNationalities = "AgGridNationalities",
  AgGridCurrencies = "AgGridCurrencies",
  AgGridVatAccounts = "AgGridVatAccounts",
}
